// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>16</span>&nbsp;&nbsp;Cherish this vine which your right hand has planted,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and the branch that you made so strong for yourself.<br> </p> </div></div>";
// Exports
module.exports = code;